import { defineComponent as i, ref as l, h as s } from "vue";
import { Hidden as m, Features as c } from "./index332.js";
let p = i({ props: { onFocus: { type: Function, required: !0 } }, setup(n) {
  let t = l(!0);
  return () => t.value ? s(m, { as: "button", type: "button", features: c.Focusable, onFocus(a) {
    a.preventDefault();
    let e, o = 50;
    function r() {
      var u;
      if (o-- <= 0) {
        e && cancelAnimationFrame(e);
        return;
      }
      if ((u = n.onFocus) != null && u.call(n)) {
        t.value = !1, cancelAnimationFrame(e);
        return;
      }
      e = requestAnimationFrame(r);
    }
    e = requestAnimationFrame(r);
  } }) : null;
} });
export {
  p as FocusSentinel
};
